<template>
  <el-dialog
    title="批量申请退费"
    :visible.sync="visible"
    width="600px"
    @close="handleClose"
  >
    <!-- 汇总信息 -->
    <el-card shadow="never" style="margin-bottom: 20px; background-color: #f5f7fa;">
      <div style="display: flex; justify-content: space-around; text-align: center;">
        <div>
          <div style="font-size: 24px; font-weight: bold; color: #409EFF;">{{ items.length }}</div>
          <div style="font-size: 12px; color: #909399;">已选记录</div>
        </div>
        <div>
          <div style="font-size: 24px; font-weight: bold; color: #67C23A;">{{ totalReceivedAmount }}</div>
          <div style="font-size: 12px; color: #909399;">合计实付金额（元）</div>
        </div>
      </div>
    </el-card>

    <!-- 退费原因 -->
    <el-form ref="form" :model="formData" label-width="100px">
      <el-form-item
        label="退费原因"
        prop="reason"
        :rules="[
          { required: true, message: '请输入退费原因', trigger: 'blur' },
          { max: 200, message: '退费原因不能超过200字', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="formData.reason"
          type="textarea"
          :rows="3"
          placeholder="请输入退费原因（必填）"
        />
      </el-form-item>
    </el-form>

    <!-- 已选记录列表（可折叠） -->
    <el-collapse v-model="activeNames">
      <el-collapse-item title="已选记录明细" name="1">
        <el-table :data="items" size="mini" border style="width: 100%">
          <el-table-column prop="feeName" label="费用名称" align="center" />
          <el-table-column prop="payerObjName" label="付费对象" align="center" />
          <el-table-column label="缴费周期" align="center">
            <template slot-scope="scope">
              {{ dfTime(scope.row.startTime) }} ~ {{ dfTime(scope.row.endTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="receivedAmount" label="实付金额" align="center" />
        </el-table>
      </el-collapse-item>
    </el-collapse>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认申请</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'BatchReturnPayFeeDialog',

  data() {
    return {
      visible: false,
      items: [],
      formData: {
        reason: ''
      },
      activeNames: [] // 默认折叠
    }
  },

  computed: {
    totalReceivedAmount() {
      let total = 0
      this.items.forEach(item => {
        const amount = parseFloat(item.receivedAmount) || 0
        total += amount
      })
      return total.toFixed(2)
    }
  },

  methods: {
    open(items) {
      this.items = items || []
      this.formData.reason = ''
      this.activeNames = []
      this.visible = true
    },

    handleClose() {
      this.items = []
      this.formData.reason = ''
      this.activeNames = []
    },

    async handleConfirm() {
      try {
        const valid = await this.$refs.form.validate()
        if (!valid) return

        this.visible = false
        this.$emit('confirm', {
          items: this.items,
          reason: this.formData.reason
        })
      } catch (error) {
        console.error('表单验证失败:', error)
      }
    },

    dfTime(time) {
      return dateFormat(time)
    }
  }
}
</script>
